var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import moment from 'moment';
import { toYuan, toFen } from '../../../utils/unit-conversion';
import { getData } from '../../../utils/storage';
import { CONTRACTCODE } from '../../../constant/validate';
import cookie from '../../../cookie/cookie';
import tooltip from '../../../components/console-common/tooltip.vue';
import returnMenu from '../../../components/console-common/menu-return.vue';
import remark from '../../../components/console-common/common-textarea.vue';
import commonImageUploader from '../../../components/console-common/common-image-uploader.vue';
import agreement from '../agreement.vue';
export default Vue.extend({
    name: 'fundLoanCreate',
    components: {
        'el-return-menu': returnMenu,
        'el-tooltip': tooltip,
        'el-remark': remark,
        'el-image-uploader': commonImageUploader,
        'el-agreement': agreement,
    },
    computed: __assign({}, mapState('common', {
        tenantCodeList: 'tenantCodeList',
        tenantCodeListLoading: 'tenantCodeListLoading',
    }), mapState('info', {
        merchantBasicInfo: 'merchantBasicInfo',
    })),
    data: function () {
        var _this = this;
        var validateOverlap = function (index) {
            var capitalRepayPlanDTOList = _this['ruleForm'].capitalRepayPlanDTOList;
            var startDate = [];
            var endDate = [];
            capitalRepayPlanDTOList.forEach(function (item, vIndex) {
                if (index === vIndex || (item.status && item.date[0])) {
                    startDate.push(item.date[0]);
                    endDate.push(item.date[1]);
                }
            });
            startDate = startDate.sort();
            endDate = endDate.sort();
            for (var i = 1; i < startDate.length; i++) {
                if (startDate[i] <= endDate[i - 1]) {
                    return false;
                }
            }
            return true;
        };
        var validateAmout = function (index) {
            var _a = _this['ruleForm'], capitalRepayPlanDTOList = _a.capitalRepayPlanDTOList, totalAmount = _a.totalAmount;
            var total = 0;
            capitalRepayPlanDTOList.forEach(function (item, vIndex) {
                if ((index === vIndex || item.status) && !isNaN(item.planAmount)) {
                    total += +item.planAmount;
                }
            });
            return total <= totalAmount;
        };
        return {
            usernameZh: '',
            isSubmit: false,
            agreementTemplateVisible: false,
            titleConfig: {
                backTitle: '返回',
                currentTitle: '新建放款订单',
                url: '/console/fund-loan-manage/loan-order-list',
            },
            imageConfig: {
                url: '/proxy/fund-file/file/capital/contract/upload',
                accessories: [
                    {
                        // 配置照片列表
                        limit: 8,
                        title: '',
                        key: 'idNoPhotos',
                        fileList: [],
                    },
                ],
            },
            ruleForm: {
                capitalRepayPlanDTOList: [],
                tenantCode: '',
                startTime: '',
                endTime: '',
            },
            rules: {
                contractCode: [
                    {
                        required: true,
                        message: '请输入线下合同号，最长20位',
                        max: 20,
                        trigger: 'blur',
                    },
                    {
                        pattern: CONTRACTCODE,
                        message: '请输入格式正确的线下合同号',
                        trigger: 'blur',
                    },
                ],
                tenantCode: [
                    { required: true, message: '请选择商户名称', trigger: 'change' },
                ],
                startTime: [
                    { required: true, message: '请选择扣款开始日期', trigger: 'change' },
                ],
                endTime: [
                    { required: true, message: '请选择扣款结束日期', trigger: 'change' },
                ],
                totalAmount: [
                    { required: true, message: '请输入放款总金额', trigger: 'blur' },
                    {
                        pattern: /^(([1-9][0-9]{0,7})|([0]\.\d{1,2}|[1-9][0-9]{0,7}\.\d{1,2}))$/,
                        message: '请输入数字，最多两位小数',
                        trigger: 'blur',
                    },
                ],
                totalDuration: [
                    { required: true, message: '请输入期数', trigger: 'blur' },
                    {
                        pattern: /(^[1-9]$)|(^[1-4][0-9]$)|(^50$)/,
                        message: '请输入1-50的正整数',
                        trigger: 'blur',
                    },
                ],
                contractNote: [{ message: '最多输入100字', trigger: 'blur', max: 100 }],
            },
            startTimePickerOptions: {
                disabledDate: function (time) {
                    if (_this['ruleForm'].endTime) {
                        var endTimeMs = _this['getDateArrToMS'](_this['ruleForm'].endTime);
                        return new Date(time).getTime() >= endTimeMs;
                    }
                    return false;
                },
            },
            endTimePickerOptions: {
                disabledDate: function (time) {
                    if (_this['ruleForm'].startTime) {
                        var startTimeMs = _this['getDateArrToMS'](_this['ruleForm'].startTime);
                        return new Date(time).getTime() <= startTimeMs;
                    }
                    return false;
                },
            },
            msgTips: {
                txt: '系统根据您录入的扣款信息对CP进行余额代扣，请确保信息准确无误',
                top: '-12px',
                left: '70px',
            },
            isShowMsgTip: false,
            isShowRemark: false,
            tabelConfig: [
                {
                    prop: 'type',
                    label: '费用类型',
                    minWidth: '160px',
                },
                {
                    prop: 'durationNo',
                    label: '期数',
                    minWidth: '75px',
                },
                {
                    prop: 'planAmount',
                    label: '扣款金额（元）',
                    minWidth: '195px',
                },
                {
                    prop: 'deductTxt',
                    label: '扣款模式',
                    minWidth: '130px',
                },
                {
                    prop: 'date',
                    label: '扣款周期',
                    minWidth: '275px',
                },
                {
                    prop: 'opt',
                    label: '操作',
                    minWidth: '120px',
                    callback: function (row, index) {
                        var num = 0;
                        var err = '';
                        if (_this['ruleForm'].capitalRepayPlanDTOList[index].status) {
                            _this['ruleForm'].capitalRepayPlanDTOList[index].status = false;
                            return;
                        }
                        _this.$refs['ruleForm']['validateField']([
                            "capitalRepayPlanDTOList." + index + ".planAmount",
                            "capitalRepayPlanDTOList." + index + ".date",
                        ], function (errorMsg) {
                            num++;
                            if (errorMsg) {
                                err = errorMsg;
                                return false;
                            }
                            if (num < 2 || err !== '') {
                                return;
                            }
                            // 验证周期是否重叠
                            if (!validateOverlap(index)) {
                                return _this.$message.error('还款计划周期不能重叠！');
                            }
                            // 验证每期金额之和是否超出总金额
                            if (!validateAmout(index)) {
                                return _this.$message.error('每期还款金额之和不能超出总金额！');
                            }
                            _this['ruleForm'].capitalRepayPlanDTOList[index].status = true;
                        });
                    },
                },
            ],
        };
    },
    created: function () {
        this.initTooltips();
        this.getUserName();
        this.searchTenantCodes();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        clearHandler: function () {
            this.searchTenantCodes();
        },
        searchTenantCodes: function (key) {
            if (key === void 0) { key = ''; }
            this.$store.dispatch('common/GET_TENANT_CODE', {
                tenantName: key,
                tenantType: 'CP',
            });
        },
        createRepaymentPlan: function () {
            var _this = this;
            var num = 0;
            this.$refs['ruleForm'].validateField(['startTime', 'endTime', 'totalAmount', 'totalDuration'], function (errorMsg) {
                num++;
                if (errorMsg) {
                    return;
                }
                if (num < 4) {
                    return;
                }
                for (var i = 0; i < _this.ruleForm.totalDuration; i++) {
                    _this.ruleForm.capitalRepayPlanDTOList.push({
                        type: '月还款金额',
                        durationNo: i + 1,
                        planAmount: '',
                        deductMode: 2,
                        deductTxt: '日扣优先',
                        date: '',
                        opt: '',
                        status: false,
                    });
                }
            });
        },
        getFormData: function () {
            var _this = this;
            var params = JSON.parse(JSON.stringify(this.ruleForm));
            var tenantCode = params.tenantCode, totalAmount = params.totalAmount;
            var _a = this.merchantBasicInfo, fullName = _a.fullName, merchantId = _a.merchantId;
            var getCompany = function (tenantCode) {
                var name = '';
                _this.tenantCodeList.forEach(function (item) {
                    if (+item.value === +tenantCode) {
                        name = item.label;
                    }
                });
                return name;
            };
            var tenantName = getCompany(tenantCode);
            params.capitalRepayPlanDTOList.map(function (item) {
                item.startTime = item.date[0];
                item.endTime = item.date[1];
                item.planAmount = toFen(item.planAmount);
                delete item.date;
                delete item.deductTxt;
                delete item.opt;
                delete item.status;
                delete item.type;
                delete item.deductMode;
            });
            return Object.assign(params, {
                tenantName: tenantName,
                capitalCode: merchantId,
                capitalName: fullName,
                operator: this.usernameZh,
                totalAmount: toFen(totalAmount),
                accessories: this.$refs.imageUpload &&
                    this.$refs.imageUpload._data.uploadKeys.join(','),
            });
        },
        submitForm: function () {
            var _this = this;
            this.$refs['ruleForm'].validate(function (valid) {
                if (!valid) {
                    return;
                }
                var params = _this.getFormData();
                var tenantName = params.tenantName;
                var isAllSave = true;
                var totalAmount = 0;
                _this.ruleForm.capitalRepayPlanDTOList.forEach(function (item) {
                    var planAmount = item.planAmount, status = item.status;
                    totalAmount += toFen(planAmount);
                    if (!status) {
                        isAllSave = false;
                    }
                });
                if (!isAllSave) {
                    return _this.$message({
                        message: '您当前有编辑状态的还款计划，请先保存后再试',
                        type: 'warning',
                    });
                }
                if (!params.capitalRepayPlanDTOList ||
                    params.capitalRepayPlanDTOList.length === 0) {
                    return _this.$message.error('请创建还款计划');
                }
                var startTime = params.capitalRepayPlanDTOList[0].startTime;
                var endTime = params.capitalRepayPlanDTOList[params.capitalRepayPlanDTOList.length - 1].endTime;
                _this.$confirm('', '', {
                    message: "<p class=\"title\">\u8BF7\u518D\u6B21\u6838\u5BF9\u60A8\u521B\u5EFA\u7684\u653E\u6B3E\u8BA2\u5355</p>\n                    <p class=\"text\">\u7CFB\u7EDF\u5C06\u4ECE<span class=\"dialog-span\">" + startTime + "\u81F3" + endTime + "</span>\n                    \u81EA\u52A8\u4EE3\u6263<span class=\"dialog-span\">" + tenantName + "</span>\u7684\u4F59\u989D\uFF0C\u6263\u6B3E\u603B\u91D1\u989D<span class=\"dialog-span\">\uFFE5" + toYuan(totalAmount) + "</span></p><p class=\"text-tips\">\n                    \u540C\u65F6\u7CFB\u7EDF\u5C06<span class=\"dialog-span underline-none\">\u81EA\u52A8\u53D1\u9001\u4F59\u989D\u4EE3\u6263\u534F\u8BAE</span>\u81F3" + tenantName + "</p>",
                    dangerouslyUseHTMLString: true,
                    distinguishCancelAndClose: false,
                    customClass: 'fund-create-dialog',
                    type: 'warning',
                })
                    .then(function () {
                    _this.$request({
                        method: 'post',
                        url: '/proxy/fund-api/capital/contract/create',
                        data: params,
                    }).then(function (res) {
                        if (!res || res.errorCode !== 0) {
                            return;
                        }
                        _this.$message({
                            message: '放款订单导入成功!',
                            type: 'success',
                        });
                        _this.isSubmit = true;
                        setTimeout(function () {
                            _this.$router.push({
                                path: '/console/fund-loan-manage/loan-order-list',
                            });
                        }, 1500);
                    });
                })
                    .catch(function () { });
            });
        },
        resetForm: function () {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u60A8\u786E\u5B9A\u8981\u91CD\u7F6E\u6263\u6B3E\u4FE1\u606F\u5417\uFF1F</p><p class=\"text\">\u7CFB\u7EDF\u4E0D\u4F1A\u4FDD\u5B58\u60A8\u6240\u505A\u7684\u66F4\u6539\uFF0C\u4ECD\u8981\u91CD\u7F6E\u5417\uFF1F</p>",
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: false,
                showClose: false,
                type: 'warning',
            })
                .then(function () {
                _this.ruleForm.capitalRepayPlanDTOList = [];
            })
                .catch(function () { });
        },
        cancle: function () {
            this.$router.push({
                path: '/console/fund-loan-manage/loan-order-list',
            });
        },
        initTooltips: function () {
            var agreement = getData("fundOrderLocalStorage_" + cookie.getCookie('usernameZh'));
            this.isShowMsgTip = agreement;
        },
        closeCallBack: function () {
            this.initTooltips();
        },
        showRemark: function () {
            this.isShowRemark = true;
        },
        toAgreement: function () {
            this.agreementTemplateVisible = true;
        },
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
        objectSpanMethod: function (_a) {
            var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
            var totalDuration = this.ruleForm.totalDuration;
            if (columnIndex === 0) {
                if (rowIndex === 0) {
                    return {
                        rowspan: totalDuration,
                        colspan: 1,
                    };
                }
                else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    };
                }
            }
        },
        getDateArrToMS: function (date) {
            var dateArr = date.split('-');
            return new Date(+dateArr[0], +dateArr[1] - 1, +dateArr[2]).getTime();
        },
        planDateLimit: function (time) {
            var _a = this.ruleForm, startTime = _a.startTime, endTime = _a.endTime;
            var startTimeArr = startTime.split('-');
            var endTimeArr = endTime.split('-');
            var currentDate = new Date();
            var minDate = new Date(startTimeArr[0], startTimeArr[1] - 1, startTimeArr[2]).getTime();
            var maxDate = new Date(endTimeArr[0], endTimeArr[1] - 1, endTimeArr[2]).getTime();
            var today = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime();
            var currentMs = new Date(time).getTime();
            if (currentMs <= today || currentMs > maxDate || currentMs < minDate) {
                return true;
            }
            return false;
        },
        getSummaries: function (param) {
            var _this = this;
            var columns = param.columns, data = param.data;
            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 1) {
                    sums[index] = data.length;
                    return;
                }
                if (index === 3) {
                    sums[index] = '日扣优先';
                    return;
                }
                if (index === 4) {
                    var list = _this.ruleForm.capitalRepayPlanDTOList;
                    sums[index] = (list[0] && list[0].date[0]
                        ? moment(list[0].date[0]).format('YYYY-MM-DD')
                        : '--') + " \u81F3 " + (list[list.length - 1] && list[list.length - 1].date[1]
                        ? moment(list[list.length - 1].date[1]).format('YYYY-MM-DD')
                        : '--');
                    return;
                }
                if (index === 5) {
                    sums[index] = '';
                    return;
                }
                var values = data.map(function (item) { return Number(item[column.property]); });
                if (!values.every(function (value) { return isNaN(value); })) {
                    sums[index] = values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return toYuan(+toFen(prev) + +toFen(curr));
                        }
                        else {
                            return toYuan(toFen(prev));
                        }
                    }, 0);
                }
                else {
                    sums[index] = 'N/A';
                }
            });
            return sums;
        },
    },
    beforeRouteLeave: function (to, from, next) {
        if (this.isSubmit) {
            next();
        }
        else {
            this.$confirm('', '', {
                message: "<p class=\"title\">\u53D6\u6D88\u521B\u5EFA\u653E\u6B3E\u8BA2\u5355\uFF1F</p><p class=\"text\">\u7CFB\u7EDF\u4E0D\u4F1A\u4FDD\u5B58\u60A8\u6240\u505A\u7684\u66F4\u6539</p>",
                dangerouslyUseHTMLString: true,
                distinguishCancelAndClose: false,
                showClose: false,
                confirmButtonText: '离开',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(function () {
                next();
            })
                .catch(function () { });
        }
    },
});
